// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBZjYUexRcAfYPjIEhYspY6DgiXEvIu18s",
  authDomain: "sal-express-roterizacao.firebaseapp.com",
  projectId: "sal-express-roterizacao",
  storageBucket: "sal-express-roterizacao.firebasestorage.app",
  messagingSenderId: "980807844154",
  appId: "1:980807844154:web:79a7560085d88a64c45003",
  measurementId: "G-32R4V5J2WK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);

export { auth, analytics };
